import classNames from "classnames";
import { FC, PropsWithChildren } from "react";
import styles from "./DisplayColumn.module.css";

type DisplayColumnProps = PropsWithChildren<{
  gap?: boolean;
  className?: string;
}>;

const DisplayColumn: FC<DisplayColumnProps> = ({ gap = false, className, children }) => {
  return <div className={classNames(className, styles.displayColumn, { [styles.gap]: gap })}>{children}</div>;
};

export default DisplayColumn;
